"use client";

import { Typography } from "@/components/ui/typography";
import type { UseCaseDocumentsProps } from "./types";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { DeliverableItem } from "@/lib/getUseCase";
import DocumentCardLinksCarousel, {
  DocumentCardLink,
} from "@/components/screen/global-components/documents/DocumentCardLinksCarousel";
import { normalizeUrl } from "@/utils/normalizeUrl";

const UseCaseDocuments = ({ content, className }: UseCaseDocumentsProps) => {
  const { deliverablesTitle, deliverablesDescription, deliverableItems } =
    content;

  if (
    !deliverablesTitle &&
    !deliverablesDescription &&
    !deliverableItems?.length
  ) {
    return null;
  }

  const documentCardLinks: DocumentCardLink[] =
    deliverableItems?.reduce((acc: DocumentCardLink[], item: DeliverableItem) => {
      const fields = item?.fields;

      if (!fields) {
        return acc;
      }

      const iconUrl = fields?.icon?.fields?.file?.url;

      const imageUrl = iconUrl
        ? iconUrl.startsWith("//")
          ? "https:" + iconUrl
          : iconUrl
        : "/placeholder.svg";

      acc.push({
        title: fields.longText,
        imageUrl,
        href: normalizeUrl(fields.linkCategory) || "#",
      });

      return acc;
    }, []) ?? [];

  return (
    <section
      className={cn(
        "section overflow-hidden bg-background-secondary lg:bg-[#fcfcfd]",
        className
      )}
    >
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col gap-4 md:justify-center md:gap-2 md:text-center">
          {!!deliverablesTitle && (
            <Typography variant="heading4">
              <h2>{deliverablesTitle}</h2>
            </Typography>
          )}
          {!!deliverablesDescription && (
            <div className="flex justify-center text-gray-600">
              <Typography variant="subHeadingSm" asChild>
                <p>{deliverablesDescription}</p>
              </Typography>
            </div>
          )}
        </div>
        <DocumentCardLinksCarousel
          cards={documentCardLinks}
          className="mt-6 lg:!mt-12"
        />
      </div>
    </section>
  );
};

export default memo(UseCaseDocuments);
